<template>
    <div class="popup">
        <div class="popup-content">
            <img src="/img/close-btn.svg" class="close-popup-btn" @click="closePopup" />
            <div class="popup-text">
                <div class="popup-title">Upload CMR</div>
                <div class="popup-description">
                    <span style="font-size: 13px; font-weight: 400">
                        <i18n-t keypath="myOrders.to_uploadCMR.title" />
                    </span>
                    <span style="font-size: 15px; font-weight: 600">
                        {{ vehicles.length }}
                        {{ vehicles.length > 1 ? " cars " : " car " }}
                    </span>
                    <span style="font-size: 13px; font-weight: 400">
                        <i18n-t keypath="myOrders.to_uploadCMR.inThisOrder" />
                    </span>
                </div>
            </div>
            <div class="upload-container">
                <div
                    v-if="!files?.length"
                    class="dashed-border-container"
                    :class="{ dragging: isDragging }"
                    @dragover.prevent="handleDragOver"
                    @dragenter.prevent="handleDragEnter"
                    @dragleave.prevent="handleDragLeave"
                    @drop.prevent="handleDrop"
                >
                    <a @click.prevent="openFileInput" class="svg-container">
                        <svg width="41" height="41">
                            <use xlink:href="/img/sprite.svg#doc"></use>
                        </svg>
                    </a>
                    <div class="text-container">
                        <span style="color: rgba(98, 118, 144, 1)">
                            <i18n-t keypath="myOrders.to_uploadCMR.dragOrDrop" />
                        </span>
                        <a
                            href=""
                            @click.prevent="openFileInput"
                            style="
                                text-decoration: underline;
                                cursor: pointer;
                                color: rgba(26, 160, 225, 1);
                            "
                        >
                            <i18n-t keypath="myOrders.to_uploadCMR.chooseFile" />
                        </a>
                        <span style="color: rgba(98, 118, 144, 1)">
                            <i18n-t keypath="myOrders.to_uploadCMR.toUpload" />
                        </span>
                        <input
                            type="file"
                            ref="fileInput"
                            @change="handleFileChange"
                            :multiple="true"
                            style="visibility: hidden"
                        />
                    </div>
                </div>
                <div
                    v-else
                    class="dashed-border-container file-list"
                    :class="{ dragging: isDragging }"
                    @dragover.prevent="handleDragOver"
                    @dragenter.prevent="handleDragEnter"
                    @dragleave.prevent="handleDragLeave"
                    @drop.prevent="handleDrop"
                >
                    <span
                        style="color: rgba(98, 118, 144, 1)"
                        v-for="(file, id) in files"
                        v-bind:key="file.name"
                        v-tippy="{
                            content: file.name,
                            placement: 'top',
                        }"
                    >
                        <svg width="17" height="17">
                            <use xlink:href="/img/sprite.svg#doc" />
                        </svg>
                        {{ truncateFileName(file.name, 26) }}
                        <b @click="deleteFile(id)">X</b>
                    </span>
                </div>
                <template v-if="uploadProgress !== null">
                    <div class="progress-container">
                        <div
                            class="progress-bar"
                            :style="{ width: `${uploadProgress}%` }"
                        ></div>
                    </div>
                    <div class="progress-label">{{ uploadProgress }}%</div>
                </template>
            </div>
            <div class="button-container">
                <div>
                    <button class="button-text cancel-button" @click="closePopup">
                        <i18n-t keypath="myOrders.to_uploadCMR.cancel" />
                    </button>
                </div>
                <div>
                    <button class="button-text decline-button" @click="fetchUploadCmr">
                        <i18n-t keypath="myOrders.to_uploadCMR.confirm" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-content {
    position: relative;
    width: 440px;
    height: 404px;
    padding: 20px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 4px;
}

.close-popup-btn {
    width: 24px;
    height: 24px;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
}

.popup-text {
    text-align: center;
}

.popup-title {
    width: 313px;
    font-size: 24px;
    font-weight: 500;
    line-height: 30px;
    letter-spacing: 0;
    margin-top: 25px;
    margin-left: auto;
    margin-right: auto;
}

.popup-description {
    width: 314px;
    line-height: 20px;
    letter-spacing: 0;
    text-align: center;
    color: rgba(98, 118, 144, 1);
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
}

.dashed-border-container {
    width: 376px;
    height: 120px;
    border-width: 1px;
    border-style: dashed;
    border-color: rgba(98, 118, 144, 0.3);
    margin: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.dashed-border-container.dragging {
    border: 2px dashed #ff0000;
}

.svg-container {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: rgba(98, 118, 144, 1);
}

.text-container {
    text-align: center;
    margin-top: 10px;
    font-size: 13px;
    font-weight: 400;
}

.file-list {
    text-align: center;
    margin-top: 10px;
    font-size: 13px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 5px;
    flex-wrap: wrap;
    overflow-x: scroll;
}
.button-container {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    border-top: 1px solid rgba(228, 234, 240, 1);
    padding-top: 10px;
    width: 439px;
    height: 65px;
    margin-left: -20px;
}

.button-container button {
    width: 116px;
    height: 40px;
    padding: 10px;
}

.button-text {
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: 0;
    text-align: center;
    text-transform: uppercase;
    width: 116px;
    height: 40px;
}

.cancel-button {
    margin-left: 32px;
    color: rgba(26, 160, 225, 1);
    background: white;
    border-radius: 4px;
    border: 1px solid rgba(26, 160, 225, 1);
}

.decline-button {
    margin-right: 32px;
    color: white;
    background: rgba(26, 160, 225, 1);
    border: none;
    border-radius: 4px;
}

.cancel-button:hover,
.decline-button:hover {
    transform: scale(1.05);
}

.upload-container {
    width: 440px;
    height: 153px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: -25px;
}

.progress-container {
    position: relative;
    width: 341px;
    height: 3px;
    margin: 10px;
    background-color: rgba(98, 118, 144, 0.1);
    border-radius: 4px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    width: 0;
    background-color: #3498db;
    transition: width 0.3s ease;
}

.progress-label {
    position: absolute;
    top: 66%;
    left: calc(100% + -42px);
    transform: translate(-50%, -50%);
    color: #333;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0;
    text-align: right;
    color: rgba(98, 118, 144, 1);
}
</style>

<script lang="ts">
import { UploadCmrPopup } from "@/dashboard/my-orders/new-popup/upload-cmr-popup/upload-cmr-popup";

export default UploadCmrPopup;
</script>
